import { useMutation } from '@tanstack/react-query';
import { makeBackendApi } from 'services/BackendApi';

/**
 * React Query mutation hook for downloading multiple images as a zip file
 * Opens the pre-signed S3 URL in a new tab on success
 */
export const useZipDownload = () => {
  const backendApi = makeBackendApi();

  return useMutation({
    mutationFn: async (uploadUuids: string[]) => {
      const response = await backendApi.downloadUploadsAsZip(uploadUuids);
      return response.data;
    },
    onSuccess: data => {
      // Open the pre-signed S3 URL in new tab to trigger download
      window.open(data.data.zipUrl, '_blank');
    },
    onError: error => {
      // Error handling - in production would show toast notification
      console.error('Failed to download images:', error);
    },
  });
};
